// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Área de conteúdo alinhada ao padrão do sistema (Empresas: 20px, TableCard: 2rem + 1rem) */
.stylesLista_root__VgViD {
  font-family: 'Roboto', -apple-system, BlinkMacSystemFont, sans-serif;
  color: #3c4043;
  padding: 20px;
  box-sizing: border-box;
}

.stylesLista_mainContent__GNVF\\+ {
  max-width: 100%;
  box-sizing: border-box;
}

/* Card branco no padrão do sistema (Paper/TableCard) */
.stylesLista_pageCard__j-ZWI {
  background: #ffffff;
  border-radius: 5px;
  box-shadow: 0 1px 2px 0 rgba(60,64,67,0.3), 0 1px 3px 1px rgba(60,64,67,0.15);
  overflow: hidden;
}

.stylesLista_pageHeader__wDcpN {
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e8eaed;
  flex-wrap: wrap;
  gap: 16px;
}

.stylesLista_pageTitle__UBfO\\+ {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #1b3a5f;
  font-size: 20px;
  font-weight: 500;
  margin: 0;
}

.stylesLista_pageTitleIcon__NJrds {
  font-size: 28px;
}

.stylesLista_headerActions__j8pT3 {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.stylesLista_filterDropdown__PGtaE {
  position: relative;
  min-width: 160px;
}

.stylesLista_filterDropdown__PGtaE select {
  width: 100%;
  padding: 10px 36px 10px 12px;
  border: 1px solid #dadce0;
  border-radius: 4px;
  font-size: 14px;
  font-family: inherit;
  color: #5f6368;
  background: #ffffff;
  cursor: pointer;
  appearance: none;
}

.stylesLista_filterDropdown__PGtaE select:focus {
  outline: none;
  border-color: #1a73e8;
}

.stylesLista_filterDropdown__PGtaE::after {
  content: '▼';
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #80868b;
  pointer-events: none;
  font-size: 10px;
}

.stylesLista_searchBox__rxtB7 {
  position: relative;
  min-width: 280px;
}

.stylesLista_searchBox__rxtB7 input {
  width: 100%;
  padding: 10px 12px 10px 40px;
  border: 1px solid #dadce0;
  border-radius: 4px;
  font-size: 14px;
  font-family: inherit;
  color: #3c4043;
  background: #ffffff;
}

.stylesLista_searchBox__rxtB7 input:focus {
  outline: none;
  border-color: #1a73e8;
}

.stylesLista_searchIcon__Xnof1 {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #9aa0a6;
  font-size: 20px;
  pointer-events: none;
}

.stylesLista_btnPrimary__5VYbS {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 24px;
  background: #1a73e8;
  color: #ffffff;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.stylesLista_btnPrimary__5VYbS:hover {
  background: #1557b0;
  box-shadow: 0 1px 3px 0 rgba(60,64,67,0.3), 0 4px 8px 3px rgba(60,64,67,0.15);
}

/* Stats - contraste claro com a área da tabela */
.stylesLista_statsContainer__OLxh8 {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 12px;
  padding: 12px 20px;
  border-bottom: 2px solid #dadce0;
  background: #eceff1;
  align-items: center;
}

.stylesLista_statCard__Vx6Uo {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid #bdc1c6;
  background: #fff;
  box-shadow: 0 1px 2px rgba(0,0,0,0.06);
}

.stylesLista_statLabel__\\+q-TI {
  font-size: 12px;
  color: #80868b;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 0;
  white-space: nowrap;
}

.stylesLista_statValue__GGQd0 {
  font-size: 20px;
  font-weight: 600;
  color: #202124;
  margin: 0;
}

/* Table */
.stylesLista_tableContainer__kJnYs {
  overflow-x: auto;
}

.stylesLista_table__lynwr {
  width: 100%;
  border-collapse: collapse;
}

.stylesLista_table__lynwr thead {
  background: #fafafa;
  position: sticky;
  top: 0;
}

.stylesLista_table__lynwr th {
  padding: 8px 14px;
  text-align: left;
  font-weight: 600;
  font-size: 0.875rem;
  color: #424242;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  white-space: nowrap;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  position: relative;
  box-sizing: border-box;
  border-bottom: 1px solid #e0e0e0;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 48px;
}

.stylesLista_table__lynwr th:hover {
  background-color: #f0f0f0;
}

.stylesLista_thContent__CZA7- {
  display: flex;
  align-items: center;
  gap: 5px;
  width: 100%;
}

.stylesLista_table__lynwr td {
  padding: 10px 14px;
  border-bottom: 1px solid #f0f0f0;
  font-size: 0.875rem;
  color: #424242;
  white-space: nowrap;
  vertical-align: middle;
}

.stylesLista_table__lynwr tbody tr:hover {
  background: #fafafa;
}

/* Colunas de texto longo: truncam com reticências em vez de quebrar linha */
.stylesLista_tdName__tZ-gk,
.stylesLista_tdAssociado__XDwf4,
.stylesLista_tdResponsavel__cKCx5 {
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Expiração: data curta, padding mínimo */
.stylesLista_tdExpiration__pMQyz {
  padding-left: 10px;
  padding-right: 10px;
  text-align: center;
}

.stylesLista_documentCell__cqq2T {
  display: flex;
  align-items: center;
  gap: 8px;
}

.stylesLista_documentBadge__\\+ZnBs {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  padding: 3px 8px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.stylesLista_documentBadgeCpf__SsfI4 {
  background: #e0f2f1;
  color: #009688;
}

.stylesLista_documentBadgeCnpj__fiUHu {
  background: #fef7e0;
  color: #fa7b17;
}

.stylesLista_documentNumber__4sc9G {
  font-size: 0.875rem;
  color: #424242;
  white-space: nowrap;
}

.stylesLista_typeBadge__I4a2S {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

.stylesLista_typeBadgeParceiro__4cokc {
  background: #e8f0fe;
  color: #1a73e8;
}

.stylesLista_typeBadgeAssociado__xkL1K {
  background: #ede7f6;
  color: #673ab7;
}

.stylesLista_statusBadge__9ZM73 {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

.stylesLista_statusDot__eAC4R {
  width: 6px;
  height: 6px;
  border-radius: 50%;
}

.stylesLista_statusBadgeActive__Wsw8J {
  background: #e6f4ea;
  color: #34a853;
}

.stylesLista_statusBadgeActive__Wsw8J .stylesLista_statusDot__eAC4R {
  background: #34a853;
}

.stylesLista_statusBadgeInactive__8dmnU {
  background: #fce8e6;
  color: #ea4335;
}

.stylesLista_statusBadgeInactive__8dmnU .stylesLista_statusDot__eAC4R {
  background: #ea4335;
}

.stylesLista_expirationNormal__7QqLQ {
  font-size: 14px;
  color: #3c4043;
}

.stylesLista_expirationWarning__TlDS3 {
  font-size: 14px;
  color: #fa7b17;
  font-weight: 500;
}

.stylesLista_expirationExpired__7e3PY {
  font-size: 14px;
  color: #ea4335;
  font-weight: 500;
}

.stylesLista_actionsCell__gQaL\\+ {
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
}

.stylesLista_tooltipWrapper__peMiz {
  position: relative;
}

.stylesLista_actionBtn__fZwMJ {
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
}

.stylesLista_actionBtnEdit__USQ0v {
  background: #e8f0fe;
  color: #1a73e8;
}

.stylesLista_actionBtnEdit__USQ0v:hover {
  background: #1a73e8;
  color: #ffffff;
}

.stylesLista_actionBtnDelete__se8E\\+ {
  background: #fce8e6;
  color: #ea4335;
}

.stylesLista_actionBtnDelete__se8E\\+:hover {
  background: #ea4335;
  color: #ffffff;
}

.stylesLista_tooltip__G-kbi {
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  background: #202124;
  color: #ffffff;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s;
  z-index: 10;
}

.stylesLista_tooltipWrapper__peMiz:hover .stylesLista_tooltip__G-kbi {
  opacity: 1;
}

.stylesLista_emptyRow__B1A2M {
  text-align: center;
  padding: 40px 16px !important;
  color: #9aa0a6;
}

/* Table Footer */
.stylesLista_tableFooter__jj42z {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-top: 1px solid #e8eaed;
  flex-wrap: wrap;
  gap: 16px;
}

.stylesLista_itemsPerPage__32qHl {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  color: #5f6368;
}

.stylesLista_itemsPerPage__32qHl select {
  padding: 6px 32px 6px 12px;
  border: 1px solid #dadce0;
  border-radius: 4px;
  font-size: 14px;
  background: #ffffff;
  cursor: pointer;
}

.stylesLista_pagination__PunIt {
  display: flex;
  gap: 8px;
  align-items: center;
}

.stylesLista_paginationBtn__DUL0c {
  min-width: 32px;
  height: 32px;
  padding: 0 8px;
  border: 1px solid #dadce0;
  background: #ffffff;
  color: #5f6368;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s;
}

.stylesLista_paginationBtn__DUL0c:hover:not(:disabled) {
  background: #f8f9fa;
  border-color: #bdc1c6;
}

.stylesLista_paginationBtn__DUL0c:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.stylesLista_paginationBtnActive__YfFWI {
  background: #1a73e8;
  color: #ffffff;
  border-color: #1a73e8;
}

.stylesLista_paginationInfo__fBrTe {
  font-size: 14px;
  color: #5f6368;
  padding: 0 8px;
}

/* Modal */
.stylesLista_modalOverlay__rxpoP {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.stylesLista_modalContent__Pv62f {
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 1px 3px 0 rgba(60,64,67,0.3), 0 4px 8px 3px rgba(60,64,67,0.15);
  max-width: 500px;
  width: 90%;
}

.stylesLista_modalHeader__1cw9n {
  padding: 20px;
  border-bottom: 1px solid #e8eaed;
}

.stylesLista_modalTitle__x1sJA {
  font-size: 18px;
  font-weight: 500;
  color: #202124;
  margin: 0;
}

.stylesLista_modalBody__AqltG {
  padding: 24px;
  color: #5f6368;
  line-height: 1.6;
}

.stylesLista_modalFooter__KMQo- {
  padding: 16px 20px;
  border-top: 1px solid #e8eaed;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.stylesLista_btnSecondary__tAL12 {
  padding: 8px 20px;
  border: 1px solid #dadce0;
  background: #ffffff;
  color: #5f6368;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.stylesLista_btnSecondary__tAL12:hover {
  background: #f8f9fa;
}

.stylesLista_btnDanger__4afue {
  padding: 8px 20px;
  border: none;
  background: #ea4335;
  color: #ffffff;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.stylesLista_btnDanger__4afue:hover {
  background: #d32f2f;
}

@media (max-width: 780px) {
  .stylesLista_root__VgViD {
    padding: 16px;
  }

  .stylesLista_pageHeader__wDcpN,
  .stylesLista_statsContainer__OLxh8,
  .stylesLista_tableFooter__jj42z {
    padding: 16px;
  }

  .stylesLista_table__lynwr th,
  .stylesLista_table__lynwr td {
    padding: 12px 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ParceirosAssociados/stylesLista.module.css"],"names":[],"mappings":"AAAA,4FAA4F;AAC5F;EACE,oEAAoE;EACpE,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA,uDAAuD;AACvD;EACE,mBAAmB;EACnB,kBAAkB;EAClB,6EAA6E;EAC7E,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gCAAgC;EAChC,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,6EAA6E;AAC/E;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA,UAAU;AACV;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;AACR;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,gCAAgC;EAChC,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,4EAA4E;AAC5E;;;EAGE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,UAAU;EACV,oBAAoB;EACpB,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,6EAA6E;EAC7E,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;;;IAGE,aAAa;EACf;;EAEA;;IAEE,kBAAkB;EACpB;AACF","sourcesContent":["/* Área de conteúdo alinhada ao padrão do sistema (Empresas: 20px, TableCard: 2rem + 1rem) */\n.root {\n  font-family: 'Roboto', -apple-system, BlinkMacSystemFont, sans-serif;\n  color: #3c4043;\n  padding: 20px;\n  box-sizing: border-box;\n}\n\n.mainContent {\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n/* Card branco no padrão do sistema (Paper/TableCard) */\n.pageCard {\n  background: #ffffff;\n  border-radius: 5px;\n  box-shadow: 0 1px 2px 0 rgba(60,64,67,0.3), 0 1px 3px 1px rgba(60,64,67,0.15);\n  overflow: hidden;\n}\n\n.pageHeader {\n  padding: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid #e8eaed;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.pageTitle {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  color: #1b3a5f;\n  font-size: 20px;\n  font-weight: 500;\n  margin: 0;\n}\n\n.pageTitleIcon {\n  font-size: 28px;\n}\n\n.headerActions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.filterDropdown {\n  position: relative;\n  min-width: 160px;\n}\n\n.filterDropdown select {\n  width: 100%;\n  padding: 10px 36px 10px 12px;\n  border: 1px solid #dadce0;\n  border-radius: 4px;\n  font-size: 14px;\n  font-family: inherit;\n  color: #5f6368;\n  background: #ffffff;\n  cursor: pointer;\n  appearance: none;\n}\n\n.filterDropdown select:focus {\n  outline: none;\n  border-color: #1a73e8;\n}\n\n.filterDropdown::after {\n  content: '▼';\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #80868b;\n  pointer-events: none;\n  font-size: 10px;\n}\n\n.searchBox {\n  position: relative;\n  min-width: 280px;\n}\n\n.searchBox input {\n  width: 100%;\n  padding: 10px 12px 10px 40px;\n  border: 1px solid #dadce0;\n  border-radius: 4px;\n  font-size: 14px;\n  font-family: inherit;\n  color: #3c4043;\n  background: #ffffff;\n}\n\n.searchBox input:focus {\n  outline: none;\n  border-color: #1a73e8;\n}\n\n.searchIcon {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #9aa0a6;\n  font-size: 20px;\n  pointer-events: none;\n}\n\n.btnPrimary {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 24px;\n  background: #1a73e8;\n  color: #ffffff;\n  border: none;\n  border-radius: 4px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btnPrimary:hover {\n  background: #1557b0;\n  box-shadow: 0 1px 3px 0 rgba(60,64,67,0.3), 0 4px 8px 3px rgba(60,64,67,0.15);\n}\n\n/* Stats - contraste claro com a área da tabela */\n.statsContainer {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\n  gap: 12px;\n  padding: 12px 20px;\n  border-bottom: 2px solid #dadce0;\n  background: #eceff1;\n  align-items: center;\n}\n\n.statCard {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  border-radius: 6px;\n  border: 1px solid #bdc1c6;\n  background: #fff;\n  box-shadow: 0 1px 2px rgba(0,0,0,0.06);\n}\n\n.statLabel {\n  font-size: 12px;\n  color: #80868b;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin: 0;\n  white-space: nowrap;\n}\n\n.statValue {\n  font-size: 20px;\n  font-weight: 600;\n  color: #202124;\n  margin: 0;\n}\n\n/* Table */\n.tableContainer {\n  overflow-x: auto;\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.table thead {\n  background: #fafafa;\n  position: sticky;\n  top: 0;\n}\n\n.table th {\n  padding: 8px 14px;\n  text-align: left;\n  font-weight: 600;\n  font-size: 0.875rem;\n  color: #424242;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  white-space: nowrap;\n  cursor: pointer;\n  user-select: none;\n  position: relative;\n  box-sizing: border-box;\n  border-bottom: 1px solid #e0e0e0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  height: 48px;\n}\n\n.table th:hover {\n  background-color: #f0f0f0;\n}\n\n.thContent {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  width: 100%;\n}\n\n.table td {\n  padding: 10px 14px;\n  border-bottom: 1px solid #f0f0f0;\n  font-size: 0.875rem;\n  color: #424242;\n  white-space: nowrap;\n  vertical-align: middle;\n}\n\n.table tbody tr:hover {\n  background: #fafafa;\n}\n\n/* Colunas de texto longo: truncam com reticências em vez de quebrar linha */\n.tdName,\n.tdAssociado,\n.tdResponsavel {\n  max-width: 160px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Expiração: data curta, padding mínimo */\n.tdExpiration {\n  padding-left: 10px;\n  padding-right: 10px;\n  text-align: center;\n}\n\n.documentCell {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.documentBadge {\n  display: inline-flex;\n  align-items: center;\n  flex-shrink: 0;\n  padding: 3px 8px;\n  border-radius: 10px;\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.documentBadgeCpf {\n  background: #e0f2f1;\n  color: #009688;\n}\n\n.documentBadgeCnpj {\n  background: #fef7e0;\n  color: #fa7b17;\n}\n\n.documentNumber {\n  font-size: 0.875rem;\n  color: #424242;\n  white-space: nowrap;\n}\n\n.typeBadge {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.typeBadgeParceiro {\n  background: #e8f0fe;\n  color: #1a73e8;\n}\n\n.typeBadgeAssociado {\n  background: #ede7f6;\n  color: #673ab7;\n}\n\n.statusBadge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.statusDot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n}\n\n.statusBadgeActive {\n  background: #e6f4ea;\n  color: #34a853;\n}\n\n.statusBadgeActive .statusDot {\n  background: #34a853;\n}\n\n.statusBadgeInactive {\n  background: #fce8e6;\n  color: #ea4335;\n}\n\n.statusBadgeInactive .statusDot {\n  background: #ea4335;\n}\n\n.expirationNormal {\n  font-size: 14px;\n  color: #3c4043;\n}\n\n.expirationWarning {\n  font-size: 14px;\n  color: #fa7b17;\n  font-weight: 500;\n}\n\n.expirationExpired {\n  font-size: 14px;\n  color: #ea4335;\n  font-weight: 500;\n}\n\n.actionsCell {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  justify-content: center;\n}\n\n.tooltipWrapper {\n  position: relative;\n}\n\n.actionBtn {\n  width: 36px;\n  height: 36px;\n  border: none;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.actionBtnEdit {\n  background: #e8f0fe;\n  color: #1a73e8;\n}\n\n.actionBtnEdit:hover {\n  background: #1a73e8;\n  color: #ffffff;\n}\n\n.actionBtnDelete {\n  background: #fce8e6;\n  color: #ea4335;\n}\n\n.actionBtnDelete:hover {\n  background: #ea4335;\n  color: #ffffff;\n}\n\n.tooltip {\n  position: absolute;\n  bottom: calc(100% + 8px);\n  left: 50%;\n  transform: translateX(-50%);\n  background: #202124;\n  color: #ffffff;\n  padding: 6px 12px;\n  border-radius: 4px;\n  font-size: 12px;\n  white-space: nowrap;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.2s;\n  z-index: 10;\n}\n\n.tooltipWrapper:hover .tooltip {\n  opacity: 1;\n}\n\n.emptyRow {\n  text-align: center;\n  padding: 40px 16px !important;\n  color: #9aa0a6;\n}\n\n/* Table Footer */\n.tableFooter {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  border-top: 1px solid #e8eaed;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.itemsPerPage {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: 14px;\n  color: #5f6368;\n}\n\n.itemsPerPage select {\n  padding: 6px 32px 6px 12px;\n  border: 1px solid #dadce0;\n  border-radius: 4px;\n  font-size: 14px;\n  background: #ffffff;\n  cursor: pointer;\n}\n\n.pagination {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.paginationBtn {\n  min-width: 32px;\n  height: 32px;\n  padding: 0 8px;\n  border: 1px solid #dadce0;\n  background: #ffffff;\n  color: #5f6368;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: all 0.2s;\n}\n\n.paginationBtn:hover:not(:disabled) {\n  background: #f8f9fa;\n  border-color: #bdc1c6;\n}\n\n.paginationBtn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.paginationBtnActive {\n  background: #1a73e8;\n  color: #ffffff;\n  border-color: #1a73e8;\n}\n\n.paginationInfo {\n  font-size: 14px;\n  color: #5f6368;\n  padding: 0 8px;\n}\n\n/* Modal */\n.modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0,0,0,0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modalContent {\n  background: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px 0 rgba(60,64,67,0.3), 0 4px 8px 3px rgba(60,64,67,0.15);\n  max-width: 500px;\n  width: 90%;\n}\n\n.modalHeader {\n  padding: 20px;\n  border-bottom: 1px solid #e8eaed;\n}\n\n.modalTitle {\n  font-size: 18px;\n  font-weight: 500;\n  color: #202124;\n  margin: 0;\n}\n\n.modalBody {\n  padding: 24px;\n  color: #5f6368;\n  line-height: 1.6;\n}\n\n.modalFooter {\n  padding: 16px 20px;\n  border-top: 1px solid #e8eaed;\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n}\n\n.btnSecondary {\n  padding: 8px 20px;\n  border: 1px solid #dadce0;\n  background: #ffffff;\n  color: #5f6368;\n  border-radius: 4px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btnSecondary:hover {\n  background: #f8f9fa;\n}\n\n.btnDanger {\n  padding: 8px 20px;\n  border: none;\n  background: #ea4335;\n  color: #ffffff;\n  border-radius: 4px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btnDanger:hover {\n  background: #d32f2f;\n}\n\n@media (max-width: 780px) {\n  .root {\n    padding: 16px;\n  }\n\n  .pageHeader,\n  .statsContainer,\n  .tableFooter {\n    padding: 16px;\n  }\n\n  .table th,\n  .table td {\n    padding: 12px 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `stylesLista_root__VgViD`,
	"mainContent": `stylesLista_mainContent__GNVF+`,
	"pageCard": `stylesLista_pageCard__j-ZWI`,
	"pageHeader": `stylesLista_pageHeader__wDcpN`,
	"pageTitle": `stylesLista_pageTitle__UBfO+`,
	"pageTitleIcon": `stylesLista_pageTitleIcon__NJrds`,
	"headerActions": `stylesLista_headerActions__j8pT3`,
	"filterDropdown": `stylesLista_filterDropdown__PGtaE`,
	"searchBox": `stylesLista_searchBox__rxtB7`,
	"searchIcon": `stylesLista_searchIcon__Xnof1`,
	"btnPrimary": `stylesLista_btnPrimary__5VYbS`,
	"statsContainer": `stylesLista_statsContainer__OLxh8`,
	"statCard": `stylesLista_statCard__Vx6Uo`,
	"statLabel": `stylesLista_statLabel__+q-TI`,
	"statValue": `stylesLista_statValue__GGQd0`,
	"tableContainer": `stylesLista_tableContainer__kJnYs`,
	"table": `stylesLista_table__lynwr`,
	"thContent": `stylesLista_thContent__CZA7-`,
	"tdName": `stylesLista_tdName__tZ-gk`,
	"tdAssociado": `stylesLista_tdAssociado__XDwf4`,
	"tdResponsavel": `stylesLista_tdResponsavel__cKCx5`,
	"tdExpiration": `stylesLista_tdExpiration__pMQyz`,
	"documentCell": `stylesLista_documentCell__cqq2T`,
	"documentBadge": `stylesLista_documentBadge__+ZnBs`,
	"documentBadgeCpf": `stylesLista_documentBadgeCpf__SsfI4`,
	"documentBadgeCnpj": `stylesLista_documentBadgeCnpj__fiUHu`,
	"documentNumber": `stylesLista_documentNumber__4sc9G`,
	"typeBadge": `stylesLista_typeBadge__I4a2S`,
	"typeBadgeParceiro": `stylesLista_typeBadgeParceiro__4cokc`,
	"typeBadgeAssociado": `stylesLista_typeBadgeAssociado__xkL1K`,
	"statusBadge": `stylesLista_statusBadge__9ZM73`,
	"statusDot": `stylesLista_statusDot__eAC4R`,
	"statusBadgeActive": `stylesLista_statusBadgeActive__Wsw8J`,
	"statusBadgeInactive": `stylesLista_statusBadgeInactive__8dmnU`,
	"expirationNormal": `stylesLista_expirationNormal__7QqLQ`,
	"expirationWarning": `stylesLista_expirationWarning__TlDS3`,
	"expirationExpired": `stylesLista_expirationExpired__7e3PY`,
	"actionsCell": `stylesLista_actionsCell__gQaL+`,
	"tooltipWrapper": `stylesLista_tooltipWrapper__peMiz`,
	"actionBtn": `stylesLista_actionBtn__fZwMJ`,
	"actionBtnEdit": `stylesLista_actionBtnEdit__USQ0v`,
	"actionBtnDelete": `stylesLista_actionBtnDelete__se8E+`,
	"tooltip": `stylesLista_tooltip__G-kbi`,
	"emptyRow": `stylesLista_emptyRow__B1A2M`,
	"tableFooter": `stylesLista_tableFooter__jj42z`,
	"itemsPerPage": `stylesLista_itemsPerPage__32qHl`,
	"pagination": `stylesLista_pagination__PunIt`,
	"paginationBtn": `stylesLista_paginationBtn__DUL0c`,
	"paginationBtnActive": `stylesLista_paginationBtnActive__YfFWI`,
	"paginationInfo": `stylesLista_paginationInfo__fBrTe`,
	"modalOverlay": `stylesLista_modalOverlay__rxpoP`,
	"modalContent": `stylesLista_modalContent__Pv62f`,
	"modalHeader": `stylesLista_modalHeader__1cw9n`,
	"modalTitle": `stylesLista_modalTitle__x1sJA`,
	"modalBody": `stylesLista_modalBody__AqltG`,
	"modalFooter": `stylesLista_modalFooter__KMQo-`,
	"btnSecondary": `stylesLista_btnSecondary__tAL12`,
	"btnDanger": `stylesLista_btnDanger__4afue`
};
export default ___CSS_LOADER_EXPORT___;
